<template>
  <div>
    <b-row>
      <b-col cols="8">
        <div class="card">
          <div class="card-body">
      <b-form @submit="onSubmit">
        <input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id"/>
        <b-form-group label="Question Text" class="required">
          <b-form-input
            type="text"
            id="dataItem-questionText-input"
            class="form-input"
            :class="{ 'is-invalid': $v.dataItem.questionText.$error }"
            v-model="dataItem.questionText"
            @blur="$v.dataItem.questionText.$touch()"
          ></b-form-input>
          <b-form-invalid-feedback>Question Text is required</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Question Type" class="required">
          <b-form-input
            type="text"
            id="dataItem-questionType-input"
            class="form-input"
            :class="{ 'is-invalid': $v.dataItem.questionType.$error }"
            v-model="dataItem.questionType"
            @blur="$v.dataItem.questionType.$touch()"
          ></b-form-input>
          <b-form-invalid-feedback>Question Type is required</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Active">
          <b-form-checkbox
            id="dataItem-active-input"
            class="form-input"
            v-model="dataItem.active">active
          </b-form-checkbox>
        </b-form-group>
        <b-button  :disabled="isSaving" type="submit" variant="primary" style="margin: 5px;"><i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
        <b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
      </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators';
  import service from '../../service';
  import { dataItemDto, dataItem } from '../../dto';

  export default {
    name: 'Addinterviewquestion',
    components: {},
    data: () => ({
      dataItem: dataItem,
      isSaving:false
    }),
    methods: {
      async onSubmit(e) {
        e.preventDefault();

        this.$v.dataItem.$touch();
        if (this.$v.dataItem.$invalid) {
          return;
        }

        try {
          let payload = new dataItemDto(this.dataItem);
          payload.id = 0; //New records will start with an id of zero
          payload.active = true; //New records will always be true
          this.isSaving = true;
          try {
            const id = await service.create(payload);
            this.cancel();
          } catch {
          }
          this.isSaving = false;
        }catch (e) {
          this.isSaving = false;
        }
      },
      cancel() {
        this.$router.push({ name: 'interviewquestions' });
      },
    },
    validations: {
      dataItem: {
        questionText: { required },
        questionType: { required },
      },
    },
  };
</script>
